import React from "react";
import { useAppContext } from "@qpr/client-api-base/context/AppCtxProvider";
import { IPeriod } from "backend/model/model";
import { usePeriod } from "backend/model/usePeriod";
import getValues from "backend/values";

import { useQuery } from "react-query";
import usePeriodLevels from "../model/usePeriodLevels";

const usePeriodFromString = (period?: string) => {
  const ctx = useAppContext();
  const periods = usePeriod();
  const { data: periodLevels } = usePeriodLevels();
  const usingPeriod = period || ctx.period || "";
  const currentPeriod = React.useMemo(() => {
    let per: IPeriod | undefined;
    periodLevels?.forEach((level) => {
      level.periods.forEach((p) => {
        if (p.name === usingPeriod) {
          per = p;
        }
      });
    });
    return per;
  }, [periods, ctx.period, usingPeriod]);

  return currentPeriod;
};

export default usePeriodFromString;
